import { observable, action, reaction, makeObservable } from 'decorators';
import auth from 'services/auth';
import log from 'services/log';
import api from 'services/api';

const _cachedTimezones = observable.map({});
reaction(() => auth.user, () => _cachedTimezones.clear());

class CachedTimezone {
  @observable.ref info;
  @observable isLoading;

  constructor(id, info) {
    makeObservable(this);
    this.id = id;
    this.info = info;
    this.isLoading = !info;

    this.promise = info ? Promise.resolve(info) : this._loadTimezone(id);
  }

  _loadTimezone(id) {
    return api.getAnon(`meta/timezones/byid?id=${encodeURIComponent(id)}`)
      .then(action(res => {
        this.info = res.data;
        this.isLoading = false;
        return res.data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        log.catchAndNotify(err);
        _cachedTimezones.delete(id);
        return null;
      }));
  }
}

export const getCachedTzFullName = id => {
  const tz = getCachedTimezone(id);
  if (!tz?.info) { return ''; }
  return `${tz.info.name} (${tz.info.abbr})`;
};

export const getCachedTzName = id => {
  const tz = getCachedTimezone(id);
  return tz?.info?.name;
};

export const getCachedTzAbbr = id => {
  const tz = getCachedTimezone(id);
  return tz?.info?.abbr;
};

export const getCachedTimezone = action(id => {
  if (!id) { return null; }

  let cached = _cachedTimezones.get(id);
  if (!cached) {
    cached = new CachedTimezone(id);
    _cachedTimezones.set(id, cached);
  }
  return cached;
});

export const loadTimezones = ({ countryCode, culture }) => {
  const getParams = {};
  if (culture) { getParams.culture = culture; }
  return api.getAnon(`meta/timezones/${countryCode}`, { params: getParams })
    .then(action(res => {
      res.data.forEach(i => {
        if (!_cachedTimezones.has(i.id)) {
          _cachedTimezones.set(i.id, new CachedTimezone(i.id, i));
        }
      });
      return res.data;
    }));
};